// For margins / paddings
export const gap = {
  none: 0,
  xxs: '0.6rem',
  xs: '0.8rem',
  sm: '1rem',
  md: '1.2rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '2.4rem',
  '3xl': '3rem',
  '4xl': '3.6rem',
};

export type Space = typeof gap;

export const size = {
  none: 0,
  vvlg: '5rem',
  vlg: '3rem',
  lg: '2rem',
  mlg: '1.5rem',
  md: '1rem',
  sm: '0.75px',
  xs: '0.5rem',
  xxs: '0.25rem',
  xxss: '0.125rem',
};

export const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
};

export const lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: 2,
  xxs: '.75rem',
  xs: '1rem',
  sm: '1.25rem',
  lg: '1.5rem',
  xl: '1.75rem',
  xxl: '2rem',
  '3xl': '2.25rem',
  '4xl': '2.5rem',
};

export const fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

export const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.875rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
  '6xl': '3.75rem',
  '7xl': '4.5rem',
  '8xl': '6rem',
  '9xl': '8rem',
};

export const fonts = {
  // eslint-disable-next-line max-len
  heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  // eslint-disable-next-line max-len
  body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  // eslint-disable-next-line max-len
  mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
};

export const breakpoints = ['40em', '52em', '64em'];
// @media screen and (min-width: 40em)
// @media screen and (min-width: 52em)
// @media screen and (min-width: 64em)
